export default __webpack_public_path__ + "static/0002-0c99a4f8bcb87ef4794c21b68009d83e.png";